module.exports = __webpack_public_path__ + "img/creative-landing.42552735.webp";